import React from "react";

import facebook from "../assets/icons/facebook.svg";
import instagram from "../assets/icons/instagram.svg";
import linkedin from "../assets/icons/linkedin.svg";
import tiktok from "../assets/icons/tiktok.svg";
import youtube from "../assets/icons/youtube.svg";

// SocialIcon supports two render modes:
// 1) Mask mode (default): colors the SVG to current text color via CSS mask
// 2) Image mode: renders the SVG as an <img>
export default function SocialIcon({
  name,
  src,
  title,
  size = "md", // xs | sm | md | lg | xl
  className = "",
  "aria-label": ariaLabel,
  alt,
  loading = "lazy",
  asMask = true,
}) {
  const iconMap = {
    facebook,
    instagram,
    linkedin,
    tiktok,
    youtube,
  };
  const key = String(name || "").toLowerCase().trim();
  const resolvedSrc =
    src || iconMap[key] || (key ? `/assets/icons/${key}.svg` : "");
  const classes = [
    "rm-social-icon",
    `rm-social-icon--size-${size}`,
    asMask ? undefined : "is-img",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const altText = alt ?? ariaLabel ?? title ?? name ?? "";

  if (asMask) {
    return (
      <span
        className={classes}
        style={{ ["--rm-social-icon-url"]: `url(${resolvedSrc})` }}
        role={altText ? "img" : undefined}
        aria-label={altText || undefined}
        title={title}
        aria-hidden={altText ? undefined : true}
      />
    );
  }

  return (
    <img
      className={classes}
      src={resolvedSrc}
      alt={altText}
      title={title}
      loading={loading}
      decoding="async"
    />
  );
}
